<template>
  <div>
    <v-carousel
      v-model="model"
      height="300"
      cycle
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item v-for="(item, index) in datas" :key="index">
        <v-sheet height="100%" tile>
          <v-row class="fill-height" align="center" justify="center">
            <iframe
              :src="returnUrl(item)"
              ref="iframe"
              width="100%"
              scrolling="no"
              style="min-height: 300px;"
            ></iframe>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: "model-view",
  computed: {
    // editorUrl() {
    //   return process.env.NODE_ENV === 'development'
    //     ? `http://localhost:4002/#/preview?id=${this.currentResource._id}`
    //     : `/preview/index.html#/preview?id=${this.currentResource._id}`
    // },
  },
  data() {
    return {
      model: 0,
      datas: [
        {
          apply_list: [
            {
              operator: "630c96865d3b64ac3d34aeff",
              remark: "",
              status: 7,
              update_at: "2023-06-21T05:57:37.375Z",
              _id: "6492915163f01a83aefa3fbd",
            },
          ],
          created_at: "2023-06-21T05:57:37.376Z",
          creator: "630c96865d3b64ac3d34aeff",
          description: "",
          function_category: "",
          industry: "",
          is_deleted: 0,
          is_model: 1,
          is_public: true,
          ishighPrecision: false,
          model_amrt_file_list_json:
            "https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/model/modelAmrtFile/气割机/轻量化后文件/AMRT模型/fileList.json",
          model_cad_file: null,
          model_category: "device",
          model_file:
            "http://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelFile/1687327055876/%E6%B0%94%E5%89%B2%E6%9C%BA.fbx",
          model_image:
            "http://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelImage/1687327055588/%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_20230614172438.png",
          model_name: "气割机",
          model_remark: "",
          model_resource_category: "device",
          model_video_file: null,
          model_view_file: null,
          one_level_classify: "01",
          profession: "01",
          sex: 0,
          status: 7,
          tagList: [],
          tags: [],
          updated_at: "2023-06-21T05:57:37.376Z",
          updater: "630c96865d3b64ac3d34aeff",
          __v: 0,
          _id: "64929151e77c083e18d4f040",
        },
        {
          apply_list: [
            {
              operator: "630c96865d3b64ac3d34aeff",
              remark: "",
              status: 7,
              update_at: "2023-06-21T06:01:57.334Z",
              _id: "6492925563f01a83aefa3fe0",
            },
          ],
          created_at: "2023-06-21T06:01:57.335Z",
          creator: "630c96865d3b64ac3d34aeff",
          description: "",
          function_category: "",
          industry: "",
          is_deleted: 0,
          is_model: 1,
          is_public: true,
          ishighPrecision: false,
          model_amrt_file_list_json:
            "https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/model/modelAmrtFile/无齿锯/轻量化后文件/AMRT模型/fileList.json",
          model_cad_file: null,
          model_category: "device",
          model_file:
            "http://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelFile/1687327316298/%E6%97%A0%E9%BD%BF%E9%94%AF.fbx",
          model_image:
            "http://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelImage/1687327315772/7a0295c6b5d0eb57e1e6ed6783b7909.png",
          model_name: "无齿锯",
          model_remark: "",
          model_resource_category: "device",
          model_video_file: null,
          model_view_file: null,
          one_level_classify: "01",
          profession: "01",
          sex: 0,
          status: 7,
          tagList: [],
          tags: [],
          updated_at: "2023-06-21T06:01:57.335Z",
          updater: "630c96865d3b64ac3d34aeff",
          __v: 0,
          _id: "64929255e77c083e18d4f1bf",
        },
        {
          apply_list: [],
          created_at: "2022-08-31T02:37:44.939Z",
          creator: "630d66425d3b64ac3d34af38",
          description: "",
          industry: 0,
          is_deleted: 0,
          is_model: 1,
          is_public: true,
          ishighPrecision: false,
          model_amrt_file_list_json:
            "https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/model/modelAmrtFile/两档十字开关/轻量化后文件/AMRT模型/fileList.json",
          model_cad_file: null,
          model_category: "device",
          model_file:
            "https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/model/modelFile/test/fdf258a89e6943af1a5a0ffc38767161/%C3%A4%C2%B8%C2%A4%C3%A6%C2%A1%C2%A3%C3%A5%C2%8D%C2%81%C3%A5%C2%AD%C2%97%C3%A5%C2%BC%C2%80%C3%A5%C2%85%C2%B3.rar",
          model_image:
            "https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/model/modelImage/test/0186f763413a8d0d67eaa363495b9981/%C3%A5%C2%BE%C2%AE%C3%A4%C2%BF%C2%A1%C3%A6%C2%88%C2%AA%C3%A5%C2%9B%C2%BE_20220831103730.png",
          model_name: "两档十字开关",
          model_resource_category: "device",
          model_video_file: null,
          model_view_file: [],
          profession: 0,
          sex: 0,
          status: 7,
          tagList: [],
          tags: [],
          updated_at: "2022-08-31T02:37:44.939Z",
          updater: "630d66425d3b64ac3d34af38",
          __v: 0,
          _id: "630ec9789ca8bdd296e02ca0",
        },
        {
          created_at: "2023-02-20T03:04:44.291Z",
          creator: "630c96865d3b64ac3d34aeff",
          description: "",
          function_category: "",
          industry: "",
          is_deleted: 0,
          is_model: 1,
          is_public: true,
          ishighPrecision: false,
          model_amrt_file_list_json:
            "https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/model/modelAmrtFile/手持喇叭/轻量化后文件/AMRT模型/fileList.json",
          model_cad_file: null,
          model_category: "device",
          model_file:
            "http://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelFile/1678707384667/%E5%96%87%E5%8F%AD.fbx",
          model_image:
            "http://metastation-dev.oss-cn-hangzhou.aliyuncs.com/modelImage/1676862282882/shouchiguangbo1.png",
          model_name: "手持喇叭",
          model_remark: "",
          model_resource_category: "device",
          model_video_file: null,
          model_view_file: null,
          one_level_classify: "04",
          profession: "04",
          sex: 0,
          status: 7,
          tagList: [],
          tags: [],
          updated_at: "2023-02-20T03:04:44.291Z",
          updater: "630c96865d3b64ac3d34aeff",
          __v: 0,
          _id: "63f2e34c258ce36ca4258e94",
        },
      ],
    };
  },
  methods: {
    returnUrl(item) {
      //  return 'http://localhost:4002/#/preview?id='+`${item._id}`
      // return "http://meta-v4.icubespace.com/preview/index.html#/preview?id=645dccafe77c083e188d7918";
      if (process.env.NODE_ENV === "development") {
        return `http://localhost:4002/#/preview?id=${item._id}`;
      }
      return `/preview/index.html#/preview?id=${item._id}`;
    },
  },
};
</script>
